<template>
  <div class="lay-body">
    <lay-menu :menuState="menuState" ></lay-menu>
    <lay-tabs :menuState="menuState" ></lay-tabs>

    <div class="menu-type" :class="{ 'menu-type-left': menuState }">

      <Tooltip :content="menuState ? '展开' : '收起'" placement="bottom-start" :transfer="true">
        <div class="menu-type-icon" :class="{ active: menuState }" @click="menuState = !menuState">
          <Icon type="md-keypad" color="#000" size="25"/>
        </div>
      </Tooltip>
    </div>


    <div class="lay-body-contetn" :class="{ 'menu-type-left': menuState }">
      <keep-alive :include="['youmu-map','common-culture','new-culture','old-culture']">
        <router-view/>
      </keep-alive>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    LayMenu: resolve => {
      require(['@/components/Layout/LayMenu.vue'], resolve);
    },
    LayTabs: resolve => {
      require(['@/components/Layout/LayTabs.vue'], resolve);
    }
  },

  data() {
    return {
      menuState: true,
      msg: 'sss'
    }
  },
  methods:{
  }


}
</script>

<style lang="less" scoped>
.lay-body {
  position: absolute;
  left: 0;
  right: 0;
  top: 70px;
  bottom: 0;

  .menu-type {
    width: 40px;
    height: 40px;
    position: absolute;
    left: 150px;
    top: 0;
    background-color: #fff;
    overflow: hidden;
    transition: all .5s;

    &-left {
      left: 60px !important;
    }

    &-icon {
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all .5s;
      transform: rotate(90deg);
      cursor: pointer;
    }

    .active {
      transform: rotate(-90deg);
    }
  }

  &-contetn {
    position: absolute;
    left: 150px;
    top: 40px;
    right: 0;
    bottom: 0;
    background-color: #fff;
    transition: all .5s;
    overflow: hidden;
  }
}
</style>

